import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buildAccountNavItems, type AccountNavSection } from '@ideoz/ui';

/**
 * The account-level sidebar nav — My Startups / Profile / Billing / App Settings.
 *
 * Root pages that aren't nested under a startup (`/profile`, `/billing`,
 * `/app-settings`) use this instead of the startup-scoped nav (Work Scopes,
 * Artifacts, …), which targets a specific startup and is meaningless at the
 * account level.
 */
export function useAccountSidebarNavItems(activeSection: AccountNavSection) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMemo(
    () =>
      buildAccountNavItems({
        t,
        activeSection,
        onNavigateToStartups: () => navigate('/startups'),
        onNavigateToProfile: () => navigate('/profile'),
        onNavigateToBilling: () => navigate('/billing'),
        onNavigateToIntegrations: () => navigate('/integrations'),
        onNavigateToAppSettings: () => navigate('/app-settings'),
      }),
    [activeSection, navigate, t]
  );
}
